import type { ReactNode } from 'react';
import { TooltipProvider } from '@witness-ai/ward-design-system';

/** Props of {@link WardScope}. */
export interface WardScopeProps {
  /** The ported pane's content. Any React node, the empty fragment included. */
  readonly children: ReactNode;
}

/**
 * The boundary of a page that renders with WARD (D6, F-6).
 *
 * A ported pane wraps its content in `WardScope`, inside `PaneFrame`. The scope renders one
 * `<div data-ward="">`. Under that attribute `src/ward/bridge.css` gives the four shared colour
 * names their WARD meaning; the frame, the rail and the header outside it keep the console's
 * meaning. The div is `display: contents`, so the scope adds no box and moves no layout.
 *
 * The scope also provides the one `TooltipProvider` a WARD `Tooltip` needs, so no pane mounts its
 * own. A portalled WARD part (Dialog, Popover, Select, Tooltip and DropdownMenu content) renders
 * outside this div, under `<body>`; its content element must carry `data-ward` itself.
 *
 * Side effects: none. It reads no context and writes no storage.
 */
export function WardScope({ children }: WardScopeProps): React.JSX.Element {
  return (
    <div data-ward="" className="contents">
      <TooltipProvider>{children}</TooltipProvider>
    </div>
  );
}
